import "./drag-and-drop-container.component.scss";

import { memo, useEffect, useState, useRef, useCallback } from "react";
import { useTranslation } from 'react-i18next';

import Button from "components/Button";
import Icon from "components/Icon";

const DragAndDropContainer = props => {
  const {
    onDrag,
    accept,
    title,
    hasDefaultImg
  } = props;

  const [imgSrc, setImgSrc] = useState({ src: null, file: null, isDefault: false });
  const [isValid, setIsValid] = useState(true);
  const hiddenInputRef = useRef(null);
  const { t } = useTranslation();

  const onDragImg = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);

  const onOpenUploadModal = useCallback(() => {
    hiddenInputRef.current.click();
  }, []);

  const onUploadFile = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();

    const uploadFiles = e.dataTransfer ? e.dataTransfer.files : (e.target.files || null);

    if (!!uploadFiles) {

      const reader = new FileReader();

      reader.onload = e => {
        setIsValid(isValidFile(uploadFiles[0].type));
        setImgSrc({
          src: e.target.result,
          file: uploadFiles[0],
          isDefault: false
        });
      };

      reader.readAsDataURL(uploadFiles[0]);

    }
  }, []);

  const isValidFile = fileType => {
    let tmpIsValid = true;

    if (accept) {
      const acceptList = accept.split(/,\s/);
      tmpIsValid = acceptList.indexOf(fileType) !== -1;
    }

    return tmpIsValid;
  };

  useEffect(() => {
    onDrag({
      imgSrc,
      isValid
    });
  }, [imgSrc]);

  useEffect(() => {
    if (!!hasDefaultImg) setImgSrc({ src: hasDefaultImg, file: null, isDefault: true })
  }, [hasDefaultImg]);

  return (
    <div className='drag-and-drop-container'>
      {/* Upload organization image */}
      <div className='modal-form-title'>{t(title || '934020c019')}</div>
      <div className='modal-form-field'>
        <div
          className={`non-upload-img-box ${!!isValid && imgSrc?.src ? 'd-none' : 'block'}`}
          onDragEnter={onDragImg}
          onDragLeave={onDragImg}
          onDragOver={onDragImg}
          onDrop={onUploadFile}
        >
          {/* Drag & Drop image here */}
          <span>{t('b6bdf5d296')}</span>
          <span className='my-4'>{t('e81c4e4f2b')}</span> {/* or */}

          <input id='non-upload-input' className='d-none' type='file' accept={accept} onChange={onUploadFile} />
          <label id='non-upload-label' htmlFor='non-upload-input'>
            <Button label={t('53a8bf3024')} onClick={e => onOpenUploadModal(e)}></Button> {/* Browse file */}
          </label>
        </div>
        <div
          className={`already-upload-img-box ${!!isValid && imgSrc?.src ? 'block' : 'd-none'}`}
          onDragEnter={onDragImg}
          onDragLeave={onDragImg}
          onDragOver={onDragImg}
          onDrop={onUploadFile}
        >
          <input id='already-upload-input' className='d-none' ref={hiddenInputRef} type="file" accept={accept} onChange={onUploadFile} />
          <label id='already-upload-label' htmlFor='already-upload-input'>
            <img src={imgSrc?.src} alt='' />
          </label>
          <div className='d-flex justify-content-between'>
            {/* Successfully */}
            <div className='upload-successful-group' style={{ visibility: imgSrc.isDefault ? "hidden" : "visible" }}>
              <Icon className="icon-message-successful" />
              <div>{t('263c0d8725')}</div>
            </div>
            <div className='d-flex align-items-center gap-2'>
              {/* re-browse file */}
              <Icon
                className="icon-edit"
                onClick={e => onOpenUploadModal(e)}
              />
              <Icon
                className="icon-trash"
                onClick={() => {
                  setIsValid(true);
                  setImgSrc({ src: null, file: null, isDefault: false, action: 'trash' });
                }}
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

DragAndDropContainer.defaultProps = {
  accept: 'image/*'
};

export default memo(DragAndDropContainer);
